import { useMemo } from 'react';

import { useCardsFilters } from './useCardsFilters';
import type { PointGetCardsFilters } from '@vlabs/api/types';

export function useWildcardCardListFiltersValue(): PointGetCardsFilters {
  const { filters } = useCardsFilters();
  return useMemo(() => ({
    ...filters,
    'user_data.fio__ilike': (filters['user_data.fio__ilike']?.length ?? 0) > 0 ? `%${filters['user_data.fio__ilike']}%` : undefined,
    'user_data.fio__like': (filters['user_data.fio__like']?.length ?? 0) > 0 ? `%${filters['user_data.fio__like']}%` : undefined,
  }), [filters]);
}
